import { Divider, Row, Col, Form, Input, Button, Icon } from 'antd';
import { passwordResetConfig as config } from './formConfig';
import HomeCaptchaForm from '../../HomeCaptchaForm';
import { ssFormUtils, ssFormValidationUtils, ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';

const
{ key } = config,
{ generateFormItem, generateInputComponent, generateInitState } = ssFormUtils,
{ validateForm, validateSubForm } = ssFormValidationUtils,
{ simpleObjectCompare, setEnvPrefix } = ssCommonUtils;

class ResetButton extends React.Component {
    constructor(props) { super(props); }
    render() {
        const { onClick } = this.props;
        return (
            <div className='ss-cmpts-reset-button-container'>
                <Button
                    size='small'
                    icon='close-circle'
                    style={{ borderRadius: '20px', width: '150px' }}
                    onClick={onClick}
                >
                    {'Close'}
                </Button>
            </div>
        );
    }
}

export default class extends React.Component {
    state = { isValid: false, captchaInput: ''}
    constructor(props) {
        super(props);
        const { storeForm, form } = this.props.data;
        if (!form[key]) storeForm(key, generateInitState(config));
        this.updateCaptchaField = this.updateCaptchaField.bind(this);
    }

    componentDidUpdate(prev) {
        const
        { storeForm, form } = this.props.data,
        cForm = form[key],
        pForm = prev.data.form[key];

        if (!simpleObjectCompare(pForm, cForm)) {
            const formState = validateForm(cForm, config, true);
            this.setState({...this.state, isValid: validateSubForm(formState) })
            storeForm(key, formState);
        }
    }
    updateCaptchaField(e){
        const
        { captchaServices } = this.props.data,
        value = e.target.value;
        if(this.state.captchaInput.length !== 8 && value.length === 8){
            captchaServices.checkCaptcha(value);
            captchaServices.updateCaptchaField(e);
        }
        this.setState((state,props) => {
            return {...state, 
                    captchaFormProps: {...state.captchaFormProps, field:value},
                    captchaInput: value
                     }
           });
    }

    render() {
        const {
            showPasswordResetModal,
            passwordResetRequest,
            captcha,
            captchaServices,
            form,
            storeForm,
            storeFormField,
            modalOnClick,
            submitPasswordReset,
            altClass,
            onResetSuccess,
            onResetFailure
        } = this.props.data,
        formData = form[key],
        buttonProps = {
            size: 'small',
            style: { width: '100%', borderRadius: '20px' }
        },
        { captchaInput } = this.state,
        defaultContainerClass = 'ss-cmpts-reg-error-password-reset',
        alternateContainerClass = 'ss-cmpts-reg-error-password-reset-alt';
        return !showPasswordResetModal ? null : (
            <div>
                <div className='ss-cmpts-password-reset-422-mask' />
                <div className={altClass != null ? !altClass ? defaultContainerClass : alternateContainerClass : defaultContainerClass}>
                    <Divider style={{ margin: '0px 0px 10px' }}>
                        <span className='ss-cmpts-error-password-reset-title'>
                            {'Retrieve Password'}
                        </span>
                    </Divider>{
                    passwordResetRequest.status === 'success' ? (
                        <div>
                            <Row type='flex' justify='space-around' align='middle' style={{ marginBottom: '7px' }}>
                                <Col>
                                    <Icon type='mail' style={{ fontSize: '50px' }} />
                                </Col>
                            </Row>
                            <Row type='flex' justify='space-around' align='middle' style={{ marginBottom: '7px' }}>
                                <Col>
                                    <div style={{ fontSize: '1.5em', fontWeight: 'bold', fontStyle: 'italic' }}>
                                        {'Email has been sent.'}
                                    </div>
                                </Col>
                            </Row>
                            <Row type='flex' justify='space-around' align='middle'>
                                <Col span={24} style={{ fontSize: '1.2em', fontStyle: 'italic', textAlign: 'center' }}>
                                    {'Please check your email for instructions to reset your password.'}
                                </Col>
                            </Row>
                            {onResetSuccess == null ? null : <ResetButton onClick={onResetSuccess} />}
                        </div>
                    ) : passwordResetRequest.status === 'failure' ? (
                        <div>
                            <Row type='flex' justify='space-around' align='middle' style={{ marginBottom: '7px' }}>
                                <Col>
                                    <Icon type='close-circle-o' style={{ fontSize: '50px' }} />
                                </Col>
                            </Row>
                            <Row type='flex' justify='space-around' align='middle' style={{ marginBottom: '7px' }}>
                                <Col>
                                    <div style={{ fontSize: '1.5em', fontWeight: 'bold', fontStyle: 'italic' }}>
                                        {'Unable to reset password.'}
                                    </div>
                                </Col>
                            </Row>
                            <Row type='flex' justify='space-around' align='middle'>
                                <Col span={24} style={{ fontSize: '1.2em', fontStyle: 'italic', textAlign: 'center' }}>
                                    {'For further assistance please contact the FTSP Help Desk.'}
                                </Col>
                            </Row>
                            {onResetSuccess == null ? null : <ResetButton onClick={onResetFailure} />}
                        </div>
                    ) : (
                        <div>
                            <Row type='flex' justify='space-around' align='middle' style={{ textAlign: 'left' }}>
                                <Col>
                                    <Form.Item {...generateFormItem('userIdOrEmail', config, formData)}>
                                        <Input {...{...generateInputComponent('userIdOrEmail', config, true, formData, storeFormField, storeForm),
                                            style: { width: '241px' }
                                        }}/>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row type='flex' justify='space-around' align='middle' style={{ textAlign: 'left', marginBottom: '20px' }}>
                                <Col>
                                <HomeCaptchaForm key='captcha'
                                        updateCaptchaField={this.updateCaptchaField}
                                        state={captcha}
                                        captchaInput={captchaInput}
                                        services={captchaServices} />

                                </Col>
                            </Row>
                            <div style={{ textAlign: 'center', marginBottom: '10px' }}>
                                <Row type='flex' justify='space-around' align='middle' gutter={10}>
                                    <Col span={24}>
                                        <Button
                                            {...buttonProps}
                                            icon='arrow-right'
                                            type='primary'
                                            disabled={!(
                                                captcha.validation.status === 'success' &&
                                                formData.userIdOrEmail_status === 'success'
                                            )}
                                            onClick={() => submitPasswordReset(formData.userIdOrEmail, captcha.field)}
                                        >
                                            {'Submit'}
                                        </Button>
                                    </Col>
                                </Row>
                            </div>
                            <div style={{ textAlign: 'center' }}>
                                <Row type='flex' justify='space-around' align='middle' gutter={10}>
                                    <Col span={12}>
                                        <Button
                                            {...buttonProps}
                                            icon='home'
                                            onClick={() => {
                                                modalOnClick();
                                                storeForm(key, generateInitState(config));
                                                window.location.href = setEnvPrefix('/home');
                                            }}
                                        >{'Home'}
                                        </Button>
                                    </Col>
                                    <Col span={12}>
                                        <Button
                                            {...buttonProps}
                                            icon='close-circle-o'
                                            onClick={() => {
                                                storeForm(key, generateInitState(config));
                                                modalOnClick();
                                            }}
                                        >{'Close'}
                                        </Button>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    )
                }</div>
            </div>
        );
    }
}
